const canViewDashboard = (currentAccount) => {
	const access = currentAccount.access;
	if (!access) return false;
	if (access.access_type !== 'BASIC') return true;

	return !!(access.access_permissions || '').split(',').find(permission => permission === '_dashboard');
};

export default canViewDashboard;
